import { useTranslation } from "react-i18next";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from 'lucide-react';
export function CardMonitoringPrograms() {
  const {
    t
  } = useTranslation("analytics");
  const navigate = useNavigate();
  return <div className="max-w-5xl mx-auto" data-id="element-2330" data-mp="dj97ogbdlsz4">
      <h1 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-2331" data-mp="dkke6nw7hetx">
        {t("pages.CardMonitoringPrograms.card_monitoring_programs")}
      </h1>
      <p className="text-gray-700 mb-2" data-id="element-2332" data-mp="1a75va558doju">
        {t("pages.CardMonitoringPrograms.card_networks_require_that_you_keep")}{' '}
        <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-2333" data-mp="118c26or3zgb1">
          {t("pages.CardMonitoringPrograms.learn_more")}
        </a>
      </p>

      <div className="mt-8" data-id="element-2334" data-mp="w9hb6zizmlfu">
        <button onClick={() => navigate('/card-monitoring/vamp')} className="w-full bg-white border border-gray-200 rounded-lg p-6 hover:border-blue-300 hover:shadow-sm transition-all text-left group" data-id="element-2335" data-mp="3lz2okw9md6gp">
          
          <h2 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-2336" data-mp="1e3t5vriwo6dt">
            {t("pages.CardMonitoringPrograms.visa_acquirer_monitoring_program_vamp")}
          </h2>
          <div className="flex items-center gap-2 text-green-600" data-id="element-2337" data-mp="154fs4mnr0vna">
            <CheckCircleIcon size={20} data-id="element-2338" data-mp="1a2poh0l7m2ah" />
            <span className="text-sm font-medium" data-id="element-2339" data-mp="1a1oaan8wczoj">{t("pages.CardMonitoringPrograms.in_good_standing")}</span>
          </div>
        </button>
      </div>
    </div>;
}